import { STANDARD_FOUR_TIME_ZONE_ID, UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccTeam } from '../acc-teams-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccTeam, unknown>[] = [
		buildColumn(util, 'Id', row => row.accTeamId, { header: 'accTeamId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.name, { header: 'Team' }),
		buildColumn(util, 'Text', row => row.ventures, { header: 'Ventures' }),
		buildColumn(util, 'Text', row => row.mentors, { header: 'Mentors' }),
		buildColumn(util, 'Text',
			row => row.meetingStartSlot !== undefined && row.meetingStartSlot !== null ? util.date.formatAccMeetingSlot(row.meetingStartSlot, STANDARD_FOUR_TIME_ZONE_ID.Eastern).acceleratorDisplayTime : 'N/A',
			{ header: 'Meeting Time' }
		), // meetingStartSlot is number | null from backend though it's defined as number | undefined, so checking for both
		buildColumn(util, 'Text', row => row.googleMeetCode ? 'Added' : 'Not Added', { header: 'Google Meet' }),
	];


	return columns;

}